module.exports = __webpack_public_path__ + "static/media/spinner.fbdef26c.gif";